module.exports = __webpack_public_path__ + "static/media/vr.3d6aeb21.png";